import Component from "@glimmer/component";
import CharCounter from "discourse/components/char-counter";

export default class ConditionalCharCounter extends Component {
  get shouldDisplayCharCounter() {
    return this.args.max > 0;
  }

  <template>
    {{#if this.shouldDisplayCharCounter}}
      <CharCounter @value={{@value}} @max={{@max}}>
        {{yield}}
      </CharCounter>
    {{else}}
      {{yield}}
    {{/if}}
  </template>
}
